export default __webpack_public_path__ + "static/cbgIsolate-4560d406cda2606e51c2cee67c9bed9d.png";